import { IData } from './types';

export const initialTodo: IData = {
  data: [
    { id: 1, label: 'Learn Golang', important: false, like: false },
    { id: 2, label: 'Learn JavaScript', important: true, like: false },
    { id: 3, label: 'Learn React', important: false, like: false }
  ]
};
